import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import SearchPanel from "../../../../../widgets/SearchPanel";
import { callApi, fnGetDataSet, fnSave } from "@shared/api/restApi";
import {
  getInitPopUp,
  getTablebySql,
  getInitFormData,
} from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SharedForm from "../../../../../widgets/SharedForm";
import SnGrid from "@shared/components/Grid/SnGrid";
import SnResizableLNR from "@shared/components/SnResizableLNR";
import SnButton from "@shared/components/SnButton";
import { showDialog } from "@widgets/CommonDialog";
import { ariaHidden } from "@mui/material/Modal/ModalManager";

interface popupProps {
  modalRef?: any;
}

interface RowData {
  KeyField?: string;

  [key: string]: any;
}

const SN_MAS_SET_REG_003_POP_002 = forwardRef(
  ({ modalRef }: popupProps, ref: React.Ref<any>) => {
    //#region Variable
    const gridref1 = useRef<any>(null);
    const searchRef = useRef<any>(null);
    const { userInfo } = global();
    //#endregion

    //#region Components useState
    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const [columns, setColums] = useState<any[]>([]);
    const [sharedForm, setSharedForm] = useState<any[]>([]);
    const [dataSource1, setDataSource1] = useState<any>();
    const SharedFormref1 = useRef<any>();
    const [focusedRowData, setFocusedRowData] = useState<any>();
    const MAX_BYTES = 80;
    //#endregion

    //#region grid 길이 관련
    let width1 = "49.5%";
    let width2 = "49.5%";
    const menuSize = localStorage.getItem("menuSize");
    if (menuSize) {
      const menu = JSON.parse(menuSize);
      if (menu.SN_MAS_SET_REG_003_POP_002) {
        width1 = menu.SN_MAS_SET_REG_003_POP_002.grid1Width
          ? menu.SN_MAS_SET_REG_003_POP_002.grid1Width
          : width1;
        width2 = menu.SN_MAS_SET_REG_003_POP_002.grid2Width
          ? menu.SN_MAS_SET_REG_003_POP_002.grid2Width
          : width2;
      }
    }
    const [grid1Width, setGrid1Width] = useState<string | number>(width1);
    const [grid2Width, setGrid2Width] = useState<string | number>(width2);

    //#endregion

    useImperativeHandle(ref, () => ({
      checkValidity: async () => {
        const modifiedRows = gridref1.current?.getChange();
        let lsChk: any = "2";
        if (modifiedRows.modifiedRowcount === 0) {
          lsChk = "1";
        } else {
          lsChk = "2";
        }

        if (lsChk === "1") {
          return { flag: false, message: "변경된 내용이 없습니다." };
        }
        return { flag: true };
      },
      getSelectedValue: async () => {
        await onSave(); // assumes it only saves modified rows
        return "success";
      },
      getSelectedRow: () => [gridref1.current.getSelectedRows() || []],
    }));

    useEffect(() => {
      const fetchform = async () => {
        setDataSource1([]);
        try {
          const rtn: any = await getInitPopUp("SN_MAS_SET_REG_003_POP_002", {});
          setFormData(rtn.formData); // 조회조건 초기값
          setFormControlData(rtn.formControlData); // 조회조건 항목 설정
          setColums(rtn.grid.grid1);
          setSharedForm(rtn.form.freeform1);
          setTimeout(() => {
            onSearch();
          }, 50);
        } catch (error) {}
      };
      fetchform();
    }, []);

    useEffect(() => {
      const txt = focusedRowData?.txt_sms ?? "";
      const byteLength = new TextEncoder().encode(txt).length;
      const remaining = MAX_BYTES - byteLength;

      setFocusedRowData((prev: any) => {
        const newState = {
          ...prev,
          label_text: `${remaining} Byte`,
        };
        return newState;
      });
    }, [focusedRowData?.txt_sms]);

    //#region onSearch
    const onSearch = async () => {
      try {
        const cd_menu = searchRef.current?.getFormdata();
        const sqlQuery2 = {
          sql: `select dc_ref from mas_codel where cd_firm = :cd_firm and cd_clas = 'MAS104' and cd_flag = 
          :cd_menu;`,
          cd_firm: userInfo.cd_firm,
          cd_menu: cd_menu.cd_menu,
        };
        const params2 = await getTablebySql(sqlQuery2);
        const params = {
          id: "sn_mas_set_reg_003_pop_002_03",
          params: {
            cd_firm: userInfo.cd_firm,
            cd_menu: params2[0].dc_ref,
          },
        };

        setDataSource1([]);
        let data: any = await fnGetDataSet(params);

        setDataSource1(data[0]);

        if (data[0] && data[0].length > 0) {
          await new Promise((resolve) => setTimeout(resolve, 50));
          gridref1.current.selectAndFocusRow(0);
        } else {
          gridref1.current.resetUpdate();
        }
      } catch (error) {}
    };

    //#endregion

    const onAddRow = async () => {
      try {
        const cd_menu = searchRef.current.getFormdata();
        const sqlQuery2 = {
          sql: `select dc_ref from mas_codel where cd_firm = :cd_firm and cd_clas = 'MAS104' and cd_flag = :cd_menu;`,
          cd_firm: userInfo.cd_firm,
          cd_menu: searchRef.current.getFormdata().cd_menu,
        };
        const params2 = await getTablebySql(sqlQuery2);
        const newRow = { cd_menu: params2[0].dc_ref };
        gridref1.current?.addRow(newRow);
      } catch (error: any) {}
    };

    const onDeleteRow = async () => {
      try {
        gridref1.current?.deleteSelectedRows();
        await gridref1.current.getFooterDataAsync();
      } catch (error) {}
    };

    const onBeforeAddRow = (newRow: RowData): boolean => {
      try {
        const allRowData: any[] = [];
        gridref1.current.api.forEachNode((node: any) => {
          allRowData.push(node.data);
        });
        const maxNoLine =
          allRowData.length > 0
            ? Math.max(...allRowData.map((row: any) => row.no_sms || 0))
            : 0;

        Object.assign(newRow, {
          cd_firm: userInfo.cd_firm,
          no_sms: maxNoLine + 1,
          yn_default: "N",
        });

        return true;
      } catch (error) {
        return false;
      }
    };

    const onSave = async () => {
      try {
        gridref1.current.api.stopEditing();
        const requiredValuesCheckH = gridref1.current.requiredValuesCheck();
        if (!requiredValuesCheckH) {
          return;
        }
        const changesRow = gridref1.current.getChange();
        const SaveData = {
          sys_smssentence: changesRow,
        };
        if (changesRow.modifiedRowcount === 0) {
          await showDialog("alter", "변경된 내용이 없습니다.");
          return;
        }
        // 저장 API 호출
        await fnSave("SN_MAS_SET_REG_003_SAVE_O1", SaveData);
        //modalRef.current?.handleConfirm?.(true, "close"); // use for new button

        gridref1.current.resetUpdate();
      } catch (error: any) {}
    };

    //#region onGrid1BtnsClick
    const onGrid1BtnsClick = async (id: string) => {
      if (id === "addRow") {
        onAddRow();
      }
      if (id === "deleteRow") {
        onDeleteRow();
      }
    };
    //#endregion

    // grid1의 width resize
    const onResizeStopH = (width: number) => {
      setGrid1Width(width);
    };

    // grid2의 width resize
    const onResizeStopL = (width: number) => {
      setGrid2Width(width);
    };

    //#region onFocusedRowChanged
    const onFocusedRowChanged = useCallback((focusedRowData: any | null) => {
      setFocusedRowData(focusedRowData);
    }, []);
    //#endregion

    //#region UI
    return (
      <div className="h-full flex flex-col">
        <div className="mb-1">
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
          />
        </div>
        <div className="flex space-x-2 flex-grow overflow-x-hidden">
          <SnResizableLNR
            width={grid1Width}
            minWidth={130}
            onResizeStop={onResizeStopH}
            enable={{ right: true }}
            menuName={modalRef.cd_menu || "SN_MAS_SET_REG_003_POP_002"}
            defaultSize={{ grid2Width: grid2Width }}
          >
            <SnGrid
              ref={gridref1}
              menuInfo={modalRef}
              enableAddRow={true}
              columnConfig={columns} // 컬럼 설정 전달
              rowData={dataSource1}
              onFocusedRowChanged={onFocusedRowChanged}
              isEditable={true}
              onBeforeAddRow={onBeforeAddRow}
            />
          </SnResizableLNR>
          <div className="flex space-x-2 flex-grow overflow-x-hidden">
            <SnResizableLNR
              width={grid2Width}
              minWidth={350}
              onResizeStop={onResizeStopL}
              enable={{ right: true }}
              menuName={modalRef.cd_menu || "SN_MAS_SET_REG_003_POP_002"}
              defaultSize={{ grid1Width: grid1Width }}
            >
              <SharedForm
                ref={SharedFormref1}
                data={focusedRowData}
                controls={sharedForm}
                gridref={gridref1}
                menuInfo={modalRef}
                title=" "
                header={
                  <div>
                    <SnButton
                      text={"➕"}
                      onClick={() => {
                        onGrid1BtnsClick("addRow");
                      }}
                    />
                    <SnButton
                      text={"➖"}
                      onClick={() => {
                        onGrid1BtnsClick("deleteRow");
                      }}
                    />
                  </div>
                }
              ></SharedForm>
            </SnResizableLNR>
          </div>
        </div>
      </div>
    );
  }
  //#endregion
);

export default SN_MAS_SET_REG_003_POP_002;
